import { FieldType, DefaultFormTableSchema } from "./types";
export class LienSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            tableData: {
                addRowButtonIsDisabled: (form, row) => {
                    const properties = (form?.["Calculator"]?.["PROPERTIES"] ||
                        []);
                    return properties.length === 0;
                },
                isDeletableRow(rowData, cells) {
                    return Boolean(rowData.addedManually);
                },
                rowFilterer(allRows, formValues) {
                    if (formValues) {
                        const refinancedProperties = formValues["Calculator"]["PROPERTIES"]
                            .filter(x => x.refinance === true)
                            .map(x => x.uniquePropertyId);
                        return allRows.filter(x => refinancedProperties.includes(x.uniquePropertyId));
                    }
                    return allRows;
                },
                rowSorter(row1, row2) {
                    const pri1 = row1.priority || 0;
                    const pri2 = row2.priority || 0;
                    if (pri1 < pri2)
                        return -1;
                    else if (pri1 > pri2)
                        return 1;
                    return 0;
                }
            },
            columnData: {
                creditorOrgNo: {
                    fieldType: FieldType.Text,
                    isEditableFunctions: {
                        canEditPropertyId: (row, columnCells) => {
                            return Boolean(row.values.addedManually);
                        }
                    }
                },
                creditorName: {
                    fieldType: FieldType.Text,
                    isRequired: true,
                    isEditableFunctions: {
                        canEditPropertyId: (row, columnCells) => {
                            return Boolean(row.values.addedManually);
                        }
                    }
                },
                registrationDate: {
                    fieldType: FieldType.Date,
                    isEditableFunctions: {
                        canEditPropertyId: (row, columnCells) => {
                            return Boolean(row.values.addedManually);
                        }
                    }
                },
                priority: {
                    fieldType: FieldType.Number
                },
                yieldPriority: {
                    fieldType: FieldType.Checkbox
                },
                documentId: {
                    fieldType: FieldType.Text,
                    isEditableFunctions: {
                        canEditPropertyId: (row, columnCells) => {
                            return Boolean(row.values.addedManually);
                        }
                    }
                },
                value: {
                    fieldType: FieldType.Currency,
                    isRequired: true
                },
                writtenDownValue: {
                    fieldType: FieldType.Currency
                },
                uniquePropertyId: {
                    fieldType: FieldType.Select,
                    isRequired: true,
                    isMultiline: true,
                    isEditableFunctions: {
                        canEditPropertyId: (row, columnCells) => {
                            return Boolean(row.values.addedManually);
                        }
                    }
                },
                reuseLien: {
                    fieldType: FieldType.Checkbox,
                    isEditableFunctions: {
                        onlyOneReusableLien: (row, columnCells, tableData) => {
                            const anyOtherLienIsReused = tableData.some(c => c.reuseLien && c.documentId !== row.values.documentId);
                            return anyOtherLienIsReused === false;
                        }
                    }
                }
            }
        });
    }
}
//# sourceMappingURL=LiensSchema.js.map